import { RouteConfig } from 'vue-router'
import { PopUpRouteConfig } from '@/shared/types/basePopUp'
import DialogDeleteConfirmation from '@/stories/dialog-delete-confirmation/DialogDeleteConfirmation.vue'
import TheUpsertLocalDelivery from '@/modules/preference/local-delivery/views/TheUpsertLocalDelivery.vue'
import { localDeliveryEndpoints } from '@/modules/preference/local-delivery'
import { localDeliveryPreviewComponents } from '@/modules/preference/local-delivery/helpers/previewComponents'

/** Local Delivery module routes */
export const localDeliveryRoutes: RouteConfig[] = [
  {
    path: '/local-delivery',
    name: 'localDelivery',
    component: () =>
      import(
        /* webpackChunkName: "TheLocalDelivery" */ '@/modules/preference/local-delivery/views/TheLocalDelivery.vue'
      ),
    meta: {
      parentRouteName: null,
      title: 'navigations.LocalDeliveryMetaTitle'
    }
  },
  {
    path: '/local-delivery/preview-details/:id',
    name: 'preview-localDelivery',
    component: () =>
      import(
        /* webpackChunkName: "ThePreviewLocalDelivery" */ '@/modules/preference/local-delivery/views/ThePreviewLocalDelivery.vue'
      ),
    meta: {
      title: 'navigations.localDeliveryMetaTitle',
      parentRouteName: 'localDelivery',
      logPage: {
        endpoint: localDeliveryEndpoints,
        previewDynamicComponents: localDeliveryPreviewComponents
      }
    }
  }
]
export const localDeliveryModalRoute: PopUpRouteConfig[] = [
  {
    component: TheUpsertLocalDelivery,
    size: 500,
    persistent: true,
    name: 'edit-localDelivery',
    requiredParams: ['id']
  },
  {
    component: TheUpsertLocalDelivery,
    size: 500,
    persistent: true,
    name: 'add-localDelivery',
    requiredParams: []
  },
  {
    component: DialogDeleteConfirmation,
    persistent: false,
    name: 'delete-localDelivery',
    requiredParams: ['id'],
    onDelete: q => localDeliveryEndpoints.delete(q.id.toString()),
    dialogTitle: 'localDeliveryTitle'
  }
]
